import fetchData from '../../api/fetchData';
import { serializePerson } from '../serializers/person';
import { safeCall } from './errors';

const PERSONS_API_URL = `${process.env.API_URL}/persons`;

export function* fetchPerson({ id, type }) {
  const apiUrl = `${PERSONS_API_URL}/${id}?type=${type}`;
  const { person } = yield safeCall(fetchData, apiUrl);
  return serializePerson(person);
}
